export const BUILD_VERSION: string | null = '1793777899196';
